import React, { useEffect, useState, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboardList } from "@fortawesome/free-solid-svg-icons";
import AdminLayout from "./AdminLayout";
import "./admin.css";

function adminFetch(path, opts = {}) {
  const token = localStorage.getItem("adminToken");
  return fetch(path, {
    ...opts,
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json", ...(opts.headers || {}) },
  });
}

export default function AdminLogs() {
  const [logs,    setLogs]    = useState([]);
  const [total,   setTotal]   = useState(0);
  const [page,    setPage]    = useState(1);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async (pg) => {
    setLoading(true);
    try {
      const res  = await adminFetch(`/api/admin/logs?page=${pg}&limit=30`);
      const data = await res.json();
      if (res.ok) { setLogs(data.logs || []); setTotal(data.total || 0); }
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(page); }, [page, load]);

  const totalPages = Math.ceil(total / 30) || 1;

  return (
    <AdminLayout pageTitle="Audit Logs">
      <div className="adm-card">
        <div className="adm-card-header">
          <h3>Activity Log</h3>
          <span style={{ fontSize: ".8rem", color: "var(--adm-muted)" }}>{total} entries</span>
        </div>

        {loading && <div className="adm-spinner-wrap"><div className="spinner-border text-secondary" /></div>}

        {!loading && logs.length === 0 && (
          <div className="adm-empty">
            <FontAwesomeIcon icon={faClipboardList} />
            <p>No log entries yet.</p>
          </div>
        )}

        {!loading && logs.length > 0 && (
          <>
            <div className="adm-table-wrap">
              <table className="adm-table">
                <thead>
                  <tr>
                    <th>Time</th>
                    <th>Admin</th>
                    <th>Role</th>
                    <th>Action</th>
                    <th>Target</th>
                    <th>IP</th>
                  </tr>
                </thead>
                <tbody>
                  {logs.map((l) => (
                    <tr key={l.id}>
                      <td style={{ fontSize: ".75rem", color: "var(--adm-muted)", whiteSpace: "nowrap" }}>
                        {l.created_at ? new Date(l.created_at).toLocaleString() : "—"}
                      </td>
                      <td style={{ fontSize: ".82rem" }}>{l.admin_email || "—"}</td>
                      <td>
                        {l.role && (
                          <span className={`adm-badge adm-role-badge ${l.role}`} style={{ fontSize: ".68rem" }}>
                            {l.role.replace("_", " ")}
                          </span>
                        )}
                      </td>
                      <td>
                        <code style={{ fontSize: ".78rem", background: "#f1f5f9", padding: ".1rem .35rem", borderRadius: 4 }}>
                          {l.action}
                        </code>
                      </td>
                      <td style={{ fontSize: ".78rem", color: "var(--adm-muted)" }}>
                        {l.target_type ? `${l.target_type}${l.target_id ? ` #${l.target_id}` : ""}` : "—"}
                      </td>
                      <td style={{ fontSize: ".75rem", color: "var(--adm-muted)" }}>{l.ip_address || "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="adm-pagination">
              <span>Page {page} of {totalPages}</span>
              <div className="adm-pag-btns">
                <button className="adm-pag-btn" disabled={page <= 1} onClick={() => setPage((p) => p - 1)}>← Prev</button>
                <button className="adm-pag-btn" disabled={page >= totalPages} onClick={() => setPage((p) => p + 1)}>Next →</button>
              </div>
            </div>
          </>
        )}
      </div>
    </AdminLayout>
  );
}
